import React from 'react';
import {Link} from 'react-router-dom'

const PremiumSMS = () => {
  return (
    <section id="premium-sms" className="py-16 bg-gradient-to-br from-blue-600 to-blue-800">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            PREMIUM SMS (PSMS)
          </h2>
          <p className="text-blue-100 text-lg max-w-3xl mx-auto">
            At Infinity Tech Africa, our Premium SMS (PSMS) services empower businesses, NGOs, 
            and content creators to earn directly through SMS billing. Customers are charged instantly 
            via their mobile network, making payments simple, secure, and accessible on any phone. 
            We manage billing, compliance, and payouts, so you can focus on delivering value and 
            growing your audience.
          </p>
        </div>

        {/* Premium SMS Card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
            <div className="relative">
              <img 
                src="/assets/premiumSMS.png" 
                alt="Premium SMS Service" 
                className="w-full h-64 object-cover"
              />
              <div className="absolute top-4 left-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                MONETIZE
              </div>
            </div>
            
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                Premium SMS (PSMS) – Simple, Secure & Accessible
              </h3>
              <p className="text-green-600 font-semibold mb-4 text-lg">
                Launch and start earning in under a week with secure telco integrations.
              </p>
              
              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Why Choose Infinity Tech Africa for Premium SMS?</h4>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Direct Carrier Billing</strong> – Payments are charged to users’ airtime or mobile bill.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>High Conversion Rates</strong> – No app downloads or bank details required.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Flexible Business Models</strong> – Pay-per-use, one-time payments, or recurring subscriptions.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Wide Reach</strong> – Integrated with major telcos in Kenya, Tanzania, Uganda, and Ghana.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-green-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Regulatory Compliance</strong> – Licensed by the Communications Authority of Kenya and fully telco-compliant.</span>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Premium SMS Service (PSMS) is Perfect For:</h4>
                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="grid md:grid-cols-2 gap-3 text-gray-700">
                    <div className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      <span>Voting & Contests <em>(TV shows, talent competitions, award voting, live polls)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      <span>Monetisation of content <em>(news alerts, astrology, sports tips, lifestyle updates)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      <span>Donations & Giving <em>(NGO campaigns, charity, church tithes & offerings)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      <span>Subscription Services <em>(daily alerts, devotional content, educational tips, premium updates)</em></span>
                    </div>
                  </div>
                </div>
              </div>

              <p className="text-green-600 font-semibold mb-6 text-center text-lg">
                With Premium SMS from Infinity Tech Africa, you can start earning revenue fast, 
                powered by secure telco integrations and transparent revenue-sharing.
              </p>

              <Link
                to="/contact"  // Make sure this matches your registration route
                className="inline-flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                <span>Start Monetizing With Premium SMS</span>
                <svg 
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-4">
              Ready to Start Earning from SMS?
            </h3>
            <p className="text-blue-100 mb-6 text-lg">
              Join content creators and businesses already generating revenue through our Premium SMS platform
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                Contact Our Team
              </Link>
              {/* <Link
                to="/contact"
                className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                Contact Our Team
              </Link> */}
            </div>
            <p className="text-yellow-200 mt-6 text-sm">
              Powered by Infinity Tech Africa. Create. Transform.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PremiumSMS;
